"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var icon_gallery_arrow_right_png_1 = __importDefault(require("@assets/icons/icon_gallery_arrow_right.png"));
function ArrowButton(props) {
    var onClick = props.onClick, id = props.id, _a = props.isDisabled, isDisabled = _a === void 0 ? false : _a, isHidden = props.isHidden;
    return (react_1.default.createElement("div", { id: id, className: (0, clsx_1.default)(isDisabled && 'disabled'), onClick: onClick, style: { opacity: isHidden ? 0 : 1, cursor: isHidden ? 'default' : 'pointer' } },
        react_1.default.createElement("img", { src: icon_gallery_arrow_right_png_1.default })));
}
exports.default = ArrowButton;
